var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 712","transform":"translate(-701 -289)"},[React.createElement("circle",{"data-name":"Ellipse 5 copy","cx":"12","cy":"12","r":"12","transform":"translate(701 289)","fill":"#fff","opacity":".5","key":0}),React.createElement("g",{"data-name":"Component 19 – 1","key":1},React.createElement("path",{"data-name":"Path 538","d":"M708 299l4.86 4.8 4.67-4.8","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}))]));
}

DropdownArrow.defaultProps = {"width":"24","height":"24"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
